<template>
  <div class="ntdiv">
    <div class="htmldiv">
      <div class="st fs28 fbold tcenter pt30 mb50 prelative">
        <div class="stborder dinline-block prelative">
          <div class="tt wd100 pabsolute">
            <div class="dinline-block fbold">
              <span class="tc11">最新</span>公告
            </div>
          </div>
        </div>
        <div class="tright more pabsolute">
           <router-link to="/notice/index" class="fr tc11 fs14 mt40 mr10 hline">更多+</router-link>
        </div>
      </div>
      <div class="cont tcenter">
        <NoticeItem v-for="(item,index) in notice" v-if="index < 6" :key="index" :index="index" :item="item"/>
      </div>
    </div>
  </div>
</template>

<script>
import NoticeItem from './notice-item.vue'
export default {
  name: "notice",
  props: [
    'notice',
  ],
  components: {
    NoticeItem,
  },
}
</script>

<style scoped>
  .index-wrap .ntdiv{height: 373px;background: url(../../assets/images/index_02.jpg) repeat-x center top;}
  .more{right: 0; top: 30px;}
</style>



// WEBPACK FOOTER //
// src/components/index/notice.vue